var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_vm._v("\n  Seja bem vindo ao backoffice, em breve teremos mais informações nessa tela.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }